/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/digital-menu-categories';

export const DigitalMenuCategoryApi = {
  find: async (option: FindOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithDigitalMenuID: async (
    menuID: string,
    option: FindDigitalMenuCategoriesWithDigitalMenuIDOption
  ) => {
    let url = `${pathname}/${menuID}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createMulti: async (body: any) => {
    try {
      const response = await entityService.post(`${pathname}/multi`, body);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateOrder: async (params: UpdateDigitalMenuCategory) => {
    const { id, body } = params;

    const url = `${pathname}/${id}/sort`;

    try {
      const response = await entityService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface UpdateDigitalMenuCategory {
  id: string;
  body: any;
}

export interface FindDigitalMenuCategoriesWithDigitalMenuIDOption {
  page: number;
  take: number;
  name?: string;
}
